module.exports = __webpack_public_path__ + "assets/empty-stars.bd846235.svg";